import { useTranslation } from 'next-i18next';
import { Spacing } from '@zep/ui';
import { RadioGroup, RadioGroupItem } from '@zep/ui/experimental';
import { CustomContactLink } from './shared/CustomContactLink';
import { PaymentTypeText } from './shared/PaymentTypeText';
import { PlanNotiText, PlanRadioLabel } from './shared';
export const DisabledTabsContent = () => {
  const {
    t
  } = useTranslation(['subscription']);
  return <>
      <RadioGroup className="flex w-full flex-col gap-[8px]" disabled data-sentry-element="RadioGroup" data-sentry-source-file="DisabledTabsContent.tsx">
        <PlanRadioLabel className="cursor-default" data-sentry-element="PlanRadioLabel" data-sentry-source-file="DisabledTabsContent.tsx">
          <div className="flex items-center gap-[8px]">
            <RadioGroupItem id="30" value="30" disabled data-sentry-element="RadioGroupItem" data-sentry-source-file="DisabledTabsContent.tsx" />
            <PaymentTypeText text={t('subscription:payment.duration.monthly', '월간 결제')} className={'text-gray-400'} data-sentry-element="PaymentTypeText" data-sentry-source-file="DisabledTabsContent.tsx" />
          </div>
          <div className="flex flex-1 justify-end">
            <CustomContactLink data-sentry-element="CustomContactLink" data-sentry-source-file="DisabledTabsContent.tsx" />
          </div>
        </PlanRadioLabel>
        <PlanRadioLabel className="cursor-default" data-sentry-element="PlanRadioLabel" data-sentry-source-file="DisabledTabsContent.tsx">
          <div className="flex items-center gap-[8px]">
            <RadioGroupItem id="30" value="30" disabled data-sentry-element="RadioGroupItem" data-sentry-source-file="DisabledTabsContent.tsx" />
            <PaymentTypeText text={t('subscription:payment.duration.annual', '연간 결제')} className={'text-gray-400'} data-sentry-element="PaymentTypeText" data-sentry-source-file="DisabledTabsContent.tsx" />
          </div>
          <div className="flex flex-1 justify-end">
            <CustomContactLink data-sentry-element="CustomContactLink" data-sentry-source-file="DisabledTabsContent.tsx" />
          </div>
        </PlanRadioLabel>
      </RadioGroup>
      <Spacing size={10} data-sentry-element="Spacing" data-sentry-source-file="DisabledTabsContent.tsx" />
      <PlanNotiText alertText={t('subscription:payment.duration.over300CcuText', '300명 이상 월/연 단위 결제는 도입 문의가 필요합니다.')} data-sentry-element="PlanNotiText" data-sentry-source-file="DisabledTabsContent.tsx" />
    </>;
};